module.exports = __webpack_public_path__ + "static/invoices-5c2882a8bf007d87121829154b0c5009.jpg";